import { Typography } from 'antd';
import { TextProps } from 'antd/lib/typography/Text';
import clsx from 'clsx';

const { Text } = Typography;

interface IMilesTextProps extends TextProps {
  color?: string;
  icon?: React.ReactNode;
  size?: 'sm' | 'md' | 'lg' | 'xl' | 'xxl';
  textWhite?: boolean;
}

export const MilesText = ({
  icon,
  size,
  color,
  strong,
  disabled,
  children,
  className,
  textWhite,
}: IMilesTextProps) => (
  <Text
    strong={strong}
    disabled={disabled}
    className={
      clsx(
        className,
        color && `text-[${color}]`,
        {
          'text-[12px]': size === 'sm',
          'text-[14px]': size === 'md',
          'text-[16px]': size === 'lg',
          'text-[18px]': size === 'xl',
          'text-[20px]': size === 'xxl',
          'text-white': textWhite,
        },
      )
    }
  >
    {icon}
    {' '}
    {children}
  </Text>
);
